import NotFound from '../views/404/404.vue'

export default {
  routes: [
    {
      path: '/404',
      component: NotFound,
      meta: {
        title: '404 Not Found'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./examples/router/404.js